module.exports = __webpack_public_path__ + "media/images/front/sp/collaboration/my_atopy_line/icon_note-1152c51df5bc852ccbfc01b4b2689427.svg";